export function visualQuickSort(array){

  let animations = []; // [type, [i,j,k], [arr[i,j,k]], reads, writes] 0=read, 1=write 2=pivot
  let reads = 0;
  let writes = 0;

  function partition(arr, left, right){
    let pivot_i = Math.floor((left+right)/2);
    let pivot = arr[pivot_i];
    let i = left;
    let j = right;

    reads += 1;
    animations.push([2, [pivot_i], [arr[pivot_i]], reads, writes]);

    while (i <= j){

      while (arr[i] < pivot){
        reads += 1
        animations.push([0, [i], [arr[i]], reads, writes]);

        i++;
      }

      while (arr[j] > pivot){
        reads += 1
        animations.push([0, [j], [arr[j]], reads, writes]);

        j--;
      }

      if (i <= j){

        animations.push([0, [i,j], [arr[i],arr[j]], reads, writes]);
        animations.push([1, [i,j], [arr[i],arr[j]], reads, writes]);

        [arr[i],arr[j]] = [arr[j],arr[i]];

        reads += 2;
        writes += 2;
        animations.push([1, [i,j], [arr[i],arr[j]], reads, writes]);
        animations.push([0, [i,j], [arr[i],arr[j]], reads, writes]);
        
        i++;
        j--;
      }
    }
    return i;
  }

  function quickSort(arr, left, right){
    let i;

    if (arr.length > 1){
      i = partition(arr, left, right);
    }

    if (left < i-1){
      quickSort(arr, left, i-1);
    }

    if (i < right){
      quickSort(arr, i, right);
    }
  }


  quickSort(array, 0, array.length -1, animations, reads, writes);

  return animations;
}
